import React from "react"
import PropTypes from "prop-types"
import ArticleSchema from "./article"
import { SeoType } from "@types/seo-type"
import { Helmet } from "react-helmet"

// This should return appropriate schema
const Schema = ({ seo, body, image, date_updated, location }) => {
  return (
    seo &&
    (seo.schema_template ? (
      <SchemaTemplate
        seo={seo}
        body={body}
        image={image}
        date_updated={date_updated}
        location={location}
      />
    ) : (
      seo.schema && (
        <Helmet>
          <script type="application/ld+json">
            {`
              ${JSON.stringify(seo.schema)}
            `}
          </script>
        </Helmet>
      )
    ))
  )
}

Schema.propTypes = {
  seo: SeoType,
  body: PropTypes.string,
  image: PropTypes.string,
  date_updated: PropTypes.string,
  location: PropTypes.object.isRequired,
}

const SchemaTemplate = ({
  seo,
  body,
  image,
  date_updated,
  location,
}) => {
  switch (seo.schema_template) {
    case "article":
    case "article-how-to":
      return (
        <ArticleSchema
          seo={seo}
          body={body}
          image={image}
          date_updated={date_updated}
          location={location}
        />
      )
  }
}

SchemaTemplate.propTypes = {
  seo: SeoType,
  body: PropTypes.string,
  image: PropTypes.string,
  date_updated: PropTypes.string.isRequired,
  location: PropTypes.object.isRequired,
}

export default Schema
